export const isHttpsConnection = window.location.protocol === 'https:'
